export default "__VITE_ASSET__CtA8mrXp__"